<template>
  <div class="h2-bg">
    <div class="circle circle-main">
      <div class="circle circle-2"></div>
      <div class="circle circle-3"></div>
      <div class="circle circle-4"></div>
    </div>
  </div>
</template>
